export function setActiveAccountNumber(accountNumber: string): void {
    sessionStorage.setItem('ActiveAccountNumber', accountNumber);
}

export function getActiveAccountNumber(): string | null {
    return sessionStorage.getItem('ActiveAccountNumber');
}
